import { combineReducers } from 'redux';
import majors from './major.reducer';

const majorAppReducer = combineReducers({
    majors,
});

export default majorAppReducer;


// WEBPACK FOOTER //
// src/main/content/major/store/reducers/index.js